/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export { IBeacon__factory } from "./IBeacon__factory";
